<section class="py-10 flex justify-center items-center bg-grey-100">
  <div class="carousel landing-section">
    <div
      class="carousel-track"
      [style.width]="spread * multiplicationCount + '%'"
      [style.animation-duration]="duration + 's'"
    >
      @for (partner of partnersMultiplied; track $index) {
        <div class="carousel-item">
          <img [src]="partner.imageUrl" [alt]="partner.name" [style.height]="partner.imageHeight + 'rem'" />
        </div>
      }
    </div>
  </div>
</section>
